<template>
  <component :is="Component" ref="componentParent" @removeMultipleForm="handleRemoveMultipleForm" @firstFetch="firstFetchDataApply">
    <template #default="{ data, loading, filter }">
      <el-tabs tab-position="top" type="card" v-model="activeName" @tab-click="handleClick" style="margin-top: 20px">
        <el-tab-pane name="form">
          <span slot="label">Danh sách phiếu</span>
          <DataTableSurveyForm @resetData="handleResetData" ref="dataTableSurveyForm" tab="survey_form" :data-table-survey-form="data" :is-loading="loading"/>
        </el-tab-pane>
        <el-tab-pane name="apply">
          <span slot="label">Danh sách áp dụng</span>
          <DataTableAppliesSurveyForm ref="dataTableAppliesSurveyForm" tab="apply_form" :data-form-filter="filter"/>
        </el-tab-pane>
      </el-tabs>
    </template>
  </component>
</template>

<script>

import DataTableSurveyForm from "@/views/survey_form/component/DataTableSurveyForm.vue";
import SurveyManagementTasks from "@/views/survey_form/component/SurveyManagementTasks.vue";
import DataTableAppliesSurveyForm from "@/views/survey_form/component/DataTableAppliesSurveyForm.vue";
import ApplicableManagementTasks from "@/views/survey_form/component/ApplicableManagementTasks.vue";

export default {
  components: {
    DataTableAppliesSurveyForm,
    DataTableSurveyForm,
    SurveyManagementTasks,
    ApplicableManagementTasks,
  },
  data() {
    return {
      activeName: 'form',
      Component: SurveyManagementTasks,
    }
  },
  methods: {
    handleClick(tab) {
      switch (tab.name) {
        case "form":
          this.Component = SurveyManagementTasks;
          break;
        case "apply":
          this.Component = ApplicableManagementTasks;
          break;
      }
    },

    handleResetData() {
      this.$refs.componentParent.handleFilterData();
    },

    handleRemoveMultipleForm() {
      this.$refs.dataTableSurveyForm.handleMultipleRemove();
    },

    firstFetchDataApply(value) {
      this.$refs.dataTableAppliesSurveyForm.initialData(value);
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__item {
  background-color: #abaca8;
  color: #fff !important;
}

/deep/ .el-tabs__item.is-active {
  background-color: #78a5e7;
  color: #fff !important;
}

/deep/ .el-tabs__header {
  display: flex;
  justify-content: flex-end; /* Đẩy tab sang phải */
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: none;
}

/deep/ .el-tabs--card > .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none;
}

/deep/ .el-tabs__nav-wrap {
  border-bottom: 1px solid #DCDFE6;
}
</style>